import { render, staticRenderFns } from "./ShippingReadOnly.vue?vue&type=template&id=6f38681a"
import script from "./ShippingReadOnly.vue?vue&type=script&lang=js"
export * from "./ShippingReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports